import type { ScreenModule } from "../../../app/screen-module";
import { ByoPolicyPage } from "../pages";

export default {
	id: "tenant-admin.byo",
	path: "/admin/byo",
	area: "tenant-admin",
	navGroup: "利用できるもの",
	label: "個人AI接続の可否",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: ByoPolicyPage,
} satisfies ScreenModule;
